import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import Users from './Users/Users'
import { CompanySetup } from './CompanySetup'
import { SalesFunnels } from './SalesFunnels'
import { SalesTeams } from './SalesTeams'
import { RolesNew } from './Roles'
import { Notifications } from './Notifications'
import { CustomFields } from './CustomFields'
import { EntityFormSettingsPage } from './EntityFormSettings'
import { ActivityTypes } from '@user/features/Activity/ActivitiyTypes'
import {
  CampaignTrackingSettings,
  useCampaignTrackingEnabled,
} from '@user/features/CampaignTracking'
import { LeadAssignmentRule } from './LeadAssignmentRule/LeadAssignmentRule'
import { SettingsHomeTidal } from '@user/components/Settings/Home/HomeTidal'
import { Notes } from '@user/components/Settings/Notes'
import { SCWebhooks } from '@user/components/Settings/SCWebhooks'
import { ImportUtility } from '@user/components/Settings/ImportUtility'
import { DoorToDoor } from '@user/components/Settings/D2D/DoorToDoor'
import { useMapViewFeatureEnabled } from '@user/store/tenantFeatures/hooks/useMapViewFeatureEnabled'
import { useD2DKnockEnabled } from '@user/store/tenantFeatures/hooks/useD2DKnockEnabled'
import { useAutoReviewPendingLeadsEnabled } from '@user/store/tenantFeatures/hooks/useAutoReviewPendingLeadsEnabled'
import { PendingLeadSettings } from '@user/components/Settings/PendingLeadSettings'
import { useServiceCodesEnabled } from '@user/store/tenantFeatures/hooks/useServiceCodesEnabled'
import { ServiceCodeSettings } from '@user/components/Settings/ServiceCodeSettings'

const Settings = () => {
  const campaignTrackingEnabled = useCampaignTrackingEnabled()
  const mapViewEnabled = useMapViewFeatureEnabled()
  const d2dEnabled = useD2DKnockEnabled()
  const pendingLeadAutoReviewEnabled = useAutoReviewPendingLeadsEnabled()
  const serviceCodesEnabled = useServiceCodesEnabled()

  return (
    <Routes>
      <Route path="/users" element={<Users />} />
      <Route path="/companySetup" element={<CompanySetup />} />
      <Route path="/salesFunnels" element={<SalesFunnels />} />
      <Route path="/salesTeams" element={<SalesTeams />} />
      <Route path="/roles" element={<RolesNew />} />
      <Route path="/notifications" element={<Notifications />} />
      <Route path="/formSettings" element={<EntityFormSettingsPage />} />
      <Route path="/customFields" element={<CustomFields />} />
      <Route path="/activities" element={<ActivityTypes />} />
      <Route path="/notes" element={<Notes />} />
      <Route path="/assignmentRules" element={<LeadAssignmentRule />} />
      <Route path="/campaignTracking" element={<CampaignTrackingSettings />} />
      <Route path="/ImportUtility" element={<ImportUtility />} />
      <Route path="/apiSettings" element={<SCWebhooks />} />
      {mapViewEnabled && d2dEnabled && (
        <Route path="/d2d" element={<DoorToDoor />} />
      )}
      {pendingLeadAutoReviewEnabled && (
        <Route path="/pendingLeadSettings" element={<PendingLeadSettings />} />
      )}
      {serviceCodesEnabled && (
        <Route path="/serviceCodeSettings" element={<ServiceCodeSettings />} />
      )}
      <Route
        path="/home"
        element={
          <SettingsHomeTidal
            mapViewEnabled={mapViewEnabled}
            d2dEnabled={d2dEnabled}
            campaignTrackingEnabled={campaignTrackingEnabled}
            pendingLeadAutoReviewEnabled={pendingLeadAutoReviewEnabled}
            serviceCodesEnabled={serviceCodesEnabled}
          />
        }
      />
    </Routes>
  )
}

export default Settings
